import React from 'react'
import { IconProps } from '../types'

export default function ColorEditIcon({
    className = 'h-[14px] w-[14px]',
    fill = '#0A84FF',
    ...props
}: IconProps) {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M12.6659 11.8352L11.8376 12.6635C11.7283 12.7722 11.5805 12.8331 11.4263 12.8331C11.2722 12.8331 11.1244 12.7722 11.0151 12.6635L4.0851 5.74518C3.89542 5.80021 3.69924 5.82963 3.50176 5.83268C3.13036 5.83242 2.76438 5.7435 2.43426 5.57331C2.10414 5.40313 1.81941 5.1566 1.60375 4.85422C1.38809 4.55184 1.24773 4.20234 1.19433 3.83479C1.14094 3.46724 1.17606 3.09226 1.29676 2.74102L2.77843 4.22268L3.0876 3.91352L3.91593 3.08518L4.2251 2.77602L2.74343 1.29435C3.09468 1.17364 3.46966 1.13853 3.83721 1.19192C4.20476 1.24531 4.55425 1.38568 4.85663 1.60134C5.15901 1.81699 5.40554 2.10172 5.57573 2.43184C5.74591 2.76196 5.83483 3.12794 5.8351 3.49935C5.83205 3.69682 5.80262 3.893 5.7476 4.08268L12.6659 11.0127C12.7746 11.122 12.8356 11.2698 12.8356 11.4239C12.8356 11.578 12.7746 11.7259 12.6659 11.8352ZM1.3376 11.0127C1.22895 11.122 1.16797 11.2698 1.16797 11.4239C1.16797 11.578 1.22895 11.7259 1.3376 11.8352L2.16593 12.6635C2.27523 12.7722 2.42307 12.8331 2.57718 12.8331C2.73129 12.8331 2.87914 12.7722 2.98843 12.6635L6.17926 9.47852L4.52843 7.82768M11.6684 1.16602L9.3351 2.33268V3.49935L8.06926 4.76518L9.23593 5.93185L10.5018 4.66602H11.6684L12.8351 2.33268L11.6684 1.16602Z"
                fill={fill}
            />
        </svg>
    )
}
